var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__info--system icon--style--fill icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 1a11 11 0 1011 11A11 11 0 0012 1zm-.015 6a1 1 0 11-1 1 1 1 0 011-1zM13 16a1 1 0 01-2 0v-4.5a1 1 0 012 0z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }